import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store, persistor } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { Navigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";

function JoinUs(props) {
  const [name, setName] = useState("");
  const [exambefore, setExamBefore] = useState("");
  const [teaching, setTeaching] = useState("");
  const [score, setScore] = useState("");
  const [location, setLocation] = useState("");
  const [number, setNumber] = useState("");
  const [experience, setExperience] = useState("");
  const [start, setStart] = useState("");
  const [file, setFile] = useState("");
  const [interest_location, setInterestLocation] = useState("");
  const [position, setPosition] = useState("");
  const [error, setError] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [flag, setFlag] = useState(false);
  const [lockSubmit, setLockSubmit] = useState(false);
  const [isDialCodeSelected, setIsDialCodeSelected] = useState(null);
  const [, setRender] = useState(false);
  const forceUpdate = () => setRender((prev) => !prev);

  const validator = useRef(
    new SimpleReactValidator({
      messages: {
        alpha_space: "Allowed only letters and spaces.",
      },
      validators: {
        nameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Full Name is required",
        },
        positionMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Position is required",
        },
        exambeforeMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Exam Before is required",
        },
        scoreMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Score is required",
        },
        locationMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Location is required",
        },
        interestlocationMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Interest Location is required",
        },
        phoneMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Phone Number is required",
        },
        dialCodeRequired: {
          rule: () => false,
          message: "Please select a dial code",
        },
        phoneValid: {
          rule: (val) => {
            if (!val) return false;
            return isValidPhoneNumber(val);
          },
          required: true,
          message: "Please enter a valid phone number for the selected country",
        },
        teachingMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Teaching is required",
        },
        startMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Start Date is required",
        },
        resumeMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "File is required",
        },
      },
    })
  );

  useEffect(() => {
    if (isDialCodeSelected == false) {
      validator.current.showMessageFor("Enter Phone Number");
    }
  }, [isDialCodeSelected]);

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "exambefore":
        setExamBefore(value);
        break;
      case "teaching":
        setTeaching(value);
        break;
      case "score":
        setScore(value);
        break;
      case "location":
        setLocation(value);
        break;
      case "number":
        setNumber(value);
        break;
      case "experience":
        setExperience(value);
        break;
      case "start":
        setStart(value);
        break;
      case "interest_location":
        setInterestLocation(value);
        break;
      case "position":
        setPosition(value);
        break;
      default:
        break;
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const submitForm = async (e) => {
    console.log({
      name,
      exambefore,
      score,
      location,
      number,
      experience,
      start,
      interest_location,
      position,
    });

    if (validator.current.allValid() && !lockSubmit) {
      setLockSubmit(true);
      e.preventDefault();

      let bodyFormData = new FormData();
      bodyFormData.append("name", name);
      bodyFormData.append("exambefore", exambefore);
      bodyFormData.append("score", score);
      bodyFormData.append("location", location);
      bodyFormData.append("number", number);
      bodyFormData.append("experience", experience);
      bodyFormData.append("start", start);
      bodyFormData.append("interest_location", interest_location);
      bodyFormData.append("position", position);
      if (file) {
        bodyFormData.append("file", file);
      }

      API({
        method: "POST",
        url: "post/join-us",
        data: bodyFormData,
      })
        .then((data) => {
          console.log(data);

          setSubmit(true);
          setLockSubmit(false);

          setName("");
          setExamBefore("");
          setScore("");
          setLocation("");
          setNumber("");
          setExperience("");
          setStart("");
          setInterestLocation("");
          setPosition("");
          setFile("");
          setFlag(true);

          store.dispatch(
            setAlert({
              flag: true,
              type: 1,
              message: data.data.response.message,
            })
          );
        })
        .catch(() => {
          setLockSubmit(false);
        });
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };

  if (flag) {
    return <Navigate to="/thank-you" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Join Our Team | On-Campus and Remote Work | LA Language Academy</title>
        <meta name="description" content="Join Our Team and Work from anywhere. We offer on-campus and remote work. We are hiring PTE tutors and admin staff, both on-campus and online. Join today!" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/join-us`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Join Our Team | On-Campus and Remote Work | LA Language Academy" />
        <meta name="twitter:description" content="Join Our Team and Work from anywhere. We offer on-campus and remote work. We are hiring PTE tutors and admin staff, both on-campus and online. Join today!" />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/join-us`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Join Our Team | On-Campus and Remote Work | LA Language Academy" />
        <meta property="og:description" content="Join Our Team and Work from anywhere. We offer on-campus and remote work. We are hiring PTE tutors and admin staff, both on-campus and online. Join today!" />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <Header />

      <div className="banner-section franchise-banner">
        <div className="container">
          <div className="row">
            <div className="banner-content">
              <h1 className="primary-heading dark-blue-color">
                <span className="wpl-badge text-white">Join Us</span>
              </h1>
              <p className="sub-title">
                Join Our Team and Work from anywhere. We offer on-campus and
                remote work. <br className="d-block" /> We are hiring PTE tutors
                and admin staff, both on-campus and online.
              </p>
              <div className="iframe-video-outer position-relative">
                {/* <div className="iframe-video-wrapper">
                      <iframe
                        className="iframe-video"
                        src="https://www.youtube.com/embed/6tJN984IoQ4?si=rlOsVJWragJc0zie"
                        title="YouTube video player"
                        frameBorder="0"
                        allowFullScreen
                      ></iframe>
                    </div> */}
                <div className="banner-img-wrapper mb-0">
                  <img
                    className="banner-img"
                    src="/images/web-new-images/banners/join-us-banner.png"
                    alt="LA"
                  />
                </div>
                <img
                  className="emoji1 position-absolute"
                  src="/images/web-new-images/emojis/hand-emoji.png"
                  alt="LA"
                />
                <img
                  className="emoji2 position-absolute"
                  src="/images/web-new-images/emojis/emoji-2.png"
                  alt="LA"
                />
                <img
                  className="emoji3 position-absolute"
                  src="/images/web-new-images/emojis/smile-icon11.png"
                  alt="LA"
                />
                <img
                  className="emoji4 position-absolute"
                  src="/images/web-new-images/emojis/emoji-4.png"
                  alt="LA"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="franchise-outer">
        <div className="joinus-heading">
          <div className="container">
            <h2 className="primary-heading text-center text-white text-uppercase fw-700">
              We are <br />{" "}
              <span className="wpl-badge text-white">hiring!</span>
            </h2>
            <p className="text-white text-center">
              Join Our Team and Work from anywhere. We offer on-campus and
              remote work.
              <br className="d-block" /> We are hiring PTE tutors and admin
              staff, both on-campus and online.
            </p>
            <div className="text-center">
              <a
                href="mailto:info@languageacademy.com.au"
                className="primary-btn"
              >
                <span className="btn-inner">
                  SEND YOUR CV
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </span>
              </a>
            </div>
          </div>
        </div>

        <section className="form-page-wrapper joinForm p-0" id="joinForm">
          <div className="container">
            <div className="row franchFormInr">
              <h2 className="primary-heading text-center text-white text-uppercase fw-700">
                Apply Now
              </h2>

              <div className="col-sm-12 formOuter pl-5 pr-5">
                <div className="form-content-outer position-relative">
                  <div className="form-content">
                    <div className="fieldOuter">
                      <label>Full Name*</label>
                      <div className="form-input-outer">
                        <input
                          className="form-input"
                          type="text"
                          placeholder="Enter Full Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      {validator.current.message(
                        "Full Name",
                        name,
                        "nameMatch"
                      )}
                    </div>

                    <div className="fieldOuter">
                      <label>Position you are applying for*</label>
                      <div className="form-input-outer form-select-wrapper">
                        <select
                          className="form-input"
                          value={position}
                          onChange={(e) => setPosition(e.target.value)}
                        >
                          <option value="PTE Traine">PTE Trainer</option>
                          <option value="Admin">Admin</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      {validator.current.message(
                        "Position",
                        position,
                        "positionMatch"
                      )}
                    </div>

                    <div className="fieldOuter">
                      <label>Have you taken the PTE exam before?*</label>
                      <div className="form-radio-wrapper">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="exambefore"
                            value="yes"
                            checked={exambefore === "yes"}
                            onChange={(e) => setExamBefore(e.target.value)}
                          />
                          <label className="form-check-label">Yes</label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="exambefore"
                            value="no"
                            checked={exambefore === "no"}
                            onChange={(e) => setExamBefore(e.target.value)}
                          />
                          <label className="form-check-label">No</label>
                        </div>
                      </div>
                      {validator.current.message(
                        "Exam Before",
                        exambefore,
                        "exambeforeMatch"
                      )}
                    </div>

                    <div className="fieldOuter">
                      <label>If yes, what was your score?*</label>
                      <div className="form-input-outer">
                        <input
                          className="form-input"
                          type="text"
                          placeholder="Enter Score"
                          value={score}
                          onChange={(e) => setScore(e.target.value)}
                        />
                      </div>
                      {validator.current.message("Score", score, "scoreMatch")}
                    </div>

                    <div className="fieldOuter">
                      <label>Where are you located?*</label>
                      <div className="form-input-outer">
                        <input
                          className="form-input"
                          type="text"
                          placeholder="Enter Location"
                          value={location}
                          onChange={(e) => setLocation(e.target.value)}
                        />
                      </div>
                      {validator.current.message(
                        "Location",
                        location,
                        "locationMatch"
                      )}
                    </div>

                    <div className="fieldOuter">
                      <label>Location you are Interested to work at*</label>
                      <div className="form-input-outer form-select-wrapper">
                        <select
                          className="form-input"
                          value={interest_location}
                          onChange={(e) => setInterestLocation(e.target.value)}
                        >
                          <option value="Parramatta">Parramatta</option>
                          <option value="Sydney CBD">Sydney CBD</option>
                          <option value="Jalandhar">Jalandhar</option>
                          <option value="Gurdaspur">Gurdaspur</option>
                          <option value="Work from home">Work from home</option>
                        </select>
                      </div>
                      {validator.current.message(
                        "Interest Location",
                        interest_location,
                        "interestlocationMatch"
                      )}
                    </div>

                    <div className="fieldOuter">
                      <label>Phone Number</label>
                      <PhoneInputField
                        id="phonenumber"
                        placeholder="Enter Phone Number"
                        value={number}
                        changeEvent={(e) => setNumber(e)}
                        onDialCodeStatusChange={(status) =>
                          setIsDialCodeSelected(status)
                        }
                      />
                      {number === ""
                        ? validator.current.message(
                          "Enter Phone Number",
                          number,
                          "phoneMatch"
                        )
                        : !isDialCodeSelected
                          ? validator.current.message(
                            "Enter Phone Number",
                            number,
                            "dialCodeRequired"
                          )
                          : validator.current.message(
                            "Enter Phone Number",
                            number,
                            "phoneValid"
                          )}
                    </div>

                    <div className="fieldOuter">
                      <label>Do you have any experience in teaching?*</label>
                      <div className="form-radio-wrapper">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="teaching"
                            value="yes"
                            checked={teaching === "yes"}
                            onChange={(e) => setTeaching(e.target.value)}
                          />
                          <label className="form-check-label">Yes</label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="teaching"
                            value="no"
                            checked={teaching === "no"}
                            onChange={(e) => setTeaching(e.target.value)}
                          />
                          <label className="form-check-label">No</label>
                        </div>
                      </div>
                      {validator.current.message(
                        "Teaching",
                        teaching,
                        "teachingMatch"
                      )}
                    </div>

                    <div className="fieldOuter">
                      <label>When can you start?*</label>
                      <div className="form-input-outer form-calendar-input">
                        <input
                          className="form-input"
                          type="date"
                          value={start}
                          onChange={(e) => setStart(e.target.value)}
                        />
                      </div>
                      {validator.current.message("Start", start, "startMatch")}
                    </div>

                    <div className="fieldOuter">
                      <label>Upload Resume/CV*</label>
                      <div className="form-input-outer form-resume-input">
                        <input
                          className="form-input"
                          type="file"
                          onChange={handleFileChange}
                        />
                      </div>
                      {validator.current.message("File", file, "resumeMatch")}
                    </div>

                    <div className="fieldOuter m-0">
                      {!lockSubmit ? (
                        <button
                          type="submit"
                          onClick={submitForm}
                          className="primary-btn"
                        >
                          SUBMIT
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="LA"
                          />
                        </button>
                      ) : (
                        <button className="primary-btn">
                          Processing...
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="LA"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default JoinUs;
